import React from 'react'
import { 
    Button, 
    CircularProgress, 
    Container, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogTitle, 
    Grid, 
    TextField, 
    Typography 
} from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { useFirestoreConnect, isLoaded } from 'react-redux-firebase'
import ReceivingCard from './ReceivingCard'
import { createNewReceivingAction } from '../../redux/actions/receiving/action'
import { toDateTime } from '../../shared/functions/toDateTime'
import { useAuth } from '../auth/AuthProvider'
import Loading from '../../shared/components/Loading'
import ShippedDetails from './ShippedDetails'




const Shipped = () => { 
    
    const {ShowCreateForm, creatHandleOpen, createOpen} = useCreateReceivingDialog()

    const [isLoading, setLoading] = React.useState(false)

    const [openDetails, setOpenDetails] = React.useState(false)
    const [items, setItems] = React.useState([])

    useFirestoreConnect(()=>[
        {collection : 'shipping_orders', where: [['ActivityStatus', '==', 'Shipped']], storeAs: 'shippedOrders'}
    ])

    const shippedOrders = useSelector(state=>state.firestore.ordered['shippedOrders'])

    React.useEffect(()=>{
        if(!isLoaded(shippedOrders)){
            setLoading(true)
        }else{
            setLoading(false)
        }
    },[shippedOrders])


    const handleOpenDetails=(data)=>{
        setItems(data)
        setOpenDetails(true)
    }
    const handleCloseDetails=()=>{
        setOpenDetails(false)
    }


    return (
        <>
         {isLoading && <Container style={{position:'absolute' , display: 'flex',left:'50%', top:0, width:300, height:300}}>
            <Loading top={200} />
        </Container>
        }

        {openDetails &&  <ShippedDetails items={items} open={openDetails} onClose={handleCloseDetails} />}

        <Grid container spacing={1}>
            {createOpen && <ShowCreateForm /> }
            {
                shippedOrders && shippedOrders?.length > 0 && 
                shippedOrders.map((ord, idx)=>{

                    return <Grid  key={idx} item xs={12} sm={3}>
                        <ReceivingCard titile={'Container code : ' +ord.ContainerCode}
                            action={()=>creatHandleOpen(ord)} 
                            actionName='Received'
                            action2Name="Details"
                            action2={()=>handleOpenDetails(ord)}
                            content={ <Typography variant="caption"> Send At : {toDateTime(ord.CreateAt.seconds).toLocaleString()} </Typography>} 
                            collapse={<Typography  variant="body2">Note : {ord.Notes} </Typography>}
                            haveCollapse ={ord.Notes !== null && ord.Notes !== ''}
                                />
                    </Grid>
                })
            }
        </Grid>
        </>
    )
}

export default Shipped



export const useCreateReceivingDialog=()=>{

    const [createOpen, setOpen] = React.useState(false)
    const [item, setItem]  = React.useState(null);
    const actionDispatch = useDispatch()
    const NoteRef = React.useRef()
    const {currentUser} = useAuth()
    
    const isLoading = useSelector(state=>state.receiving.isLoading)

    const creatHandleOpen=(item)=>{
        setItem(item)
        setOpen(true)
    }

    const handleclose=()=>{
        setOpen(false)
        setItem(null)
    }

    const handleCreate=React.useCallback(()=>{
        const receiving = {
            isOpen  : true,
            ContainerCode : item.ContainerCode,
            CreateAt : new Date(),
            UpdateAt : new Date(),
            Note  : NoteRef.current.value,
            ShippingId : item.id,
            ReceivedItems : [],
            UserId : currentUser.uid,
            UserName : currentUser.displayName,
        };

        actionDispatch(createNewReceivingAction({ receiving : receiving, callback: handleclose }))
    },[item, actionDispatch, currentUser])

    const ShowCreateForm=React.useCallback(()=>{

        return (
            <Dialog open={createOpen} onClose={handleclose}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
                aria-labelledby="form-dialog-title">
                <DialogTitle> {"Crée une nouvelle reception à partir du : " + item?.ContainerCode}  </DialogTitle>
                <DialogContent>
                    <TextField 
                        autoFocus
                        margin="dense"
                        label="Notes " 
                        inputRef={NoteRef}
                        multiline
                        variant="outlined"
                        type="text"
                        fullWidth
                        />
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} onClick={handleclose} color="secondary"> 
                        annuler
                    </Button>
                    <Button disabled={isLoading} onClick={handleCreate} color="primary"> 
                        { isLoading ? <CircularProgress size={15} color="primary" /> : "creer"}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    },[handleCreate, createOpen, item, isLoading])


    return {
        createOpen,
        creatHandleOpen,
        handleclose,
        ShowCreateForm
    }
}